import { diffWords } from "diff";

type WordsDiffProps = {
  showRemoved?: boolean;
  /**
   * When true, treat previous/current as atomic labels: if they differ, highlight
   * the full previous (removed) or current (added) string instead of a word diff.
   * Use for enum-like values that share tokens (e.g. "Not Visible…" → "Visible…").
   */
  wholeValue?: boolean;
  previous?: string;
  current?: string;
};

const REMOVED_STYLE = {
  backgroundColor: "#f8d4d4",
  textDecoration: "line-through" as const,
};

const ADDED_STYLE = {
  backgroundColor: "#d4f8d4",
  textDecoration: "none" as const,
};

const UNCHANGED_STYLE = {
  backgroundColor: "transparent",
  textDecoration: "none" as const,
};

const WordsDiff = ({
  showRemoved = false,
  wholeValue = false,
  previous,
  current,
}: WordsDiffProps) => {
  const previousText = previous || "";
  const currentText = current || "";

  if (wholeValue) {
    if (previousText === currentText) {
      return (
        <div>
          <span style={UNCHANGED_STYLE}>{currentText}</span>
        </div>
      );
    }

    if (showRemoved) {
      return (
        <div>
          <span style={REMOVED_STYLE}>{previousText}</span>
        </div>
      );
    }

    return (
      <div>
        <span style={ADDED_STYLE}>{currentText}</span>
      </div>
    );
  }

  return (
    <div>
      {diffWords(previousText, currentText).map((part, index) => {
        if (showRemoved && part.added) return null;
        if (!showRemoved && part.removed) return null;

        return (
          <span
            key={index}
            style={
              part.removed && showRemoved
                ? REMOVED_STYLE
                : part.added && !showRemoved
                  ? ADDED_STYLE
                  : UNCHANGED_STYLE
            }
          >
            {part.value}
          </span>
        );
      })}
    </div>
  );
};

export default WordsDiff;
